export default __webpack_public_path__ + "static/media/EN_02.860be977.svg";